/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "7AEC15EB-4713-46F3-8D81-B6FD2956C942",
  "siteName": "Discovery Website JSS",
  "sitecoreApiHost": "",
  "jssAppName": "dw-jss-discovery-website",
  "defaultLanguage": "en",
  "lotApi": {
    "endpoint": "https://integration.christies.com/lotdetails_webapi/api/lots/GetLotDetails",
    "key": "708878A1-95DB-4DC2-8FBD-1E8A1DCE703C"
  },
  "auctionPropertiesApi": {
    "endpoint": "https://dw-sit2-cd.christies.com/api/discoverywebsite/auctionpages/properties"
  }
};